import Clarity from '@microsoft/clarity';

function withClarity(projectId, action) {
  if (!projectId || typeof window === 'undefined') return;

  Clarity.init(projectId);
  action(Clarity);
}

export function initClarity(projectId) {
  withClarity(projectId, () => {});
}

export function setClarityTag(projectId, key, value) {
  withClarity(projectId, (clarity) => {
    clarity.setTag(key, value);
  });
}

export function identifyClarity(
  projectId,
  customId,
  customSessionId,
  customPageId,
) {
  if (!customId) return;

  withClarity(projectId, (clarity) => {
    clarity.identify(customId, customSessionId, customPageId);
  });
}

export function trackClarityEvent(projectId, eventName) {
  if (!eventName) return;

  withClarity(projectId, (clarity) => {
    clarity.event(eventName);
  });
}
